"use client"
import { useJobsContext } from "@/app/[locale]/career/jobs/JobsContext"
import styled from "@emotion/styled"
import CustomDialog from "../CustomDialog/CustomDialog"
import { mediaQueries } from "../theme/mediaQueries"
import FailureState from "./CopyOfPolicyBlock/FailureState"
import SuccessState from "./CopyOfPolicyBlock/SuccessState"

const StyledCustomDialog = styled(CustomDialog)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 0px;
  ${mediaQueries.tabletDown} {
    margin-left: 35px;
    margin-right: 35px;
    margin-top: 180px;
  }
  .MuiPaper-root {
    padding: 0px;
    height: auto;
    border-radius: 16px;
    width: auto;
    overflow: hidden;
  }
`
const formSuccessAndFailure = ({ data, id }: any) => {
  const {
    showFailedDialog,
    showSuccessDialog,
    setShowSuccessDialog,
    setShowFailedDialog,
  } = useJobsContext()

  return (
    <>
      <StyledCustomDialog
        open={showSuccessDialog}
        handleClose={() => setShowSuccessDialog(false)}
      >
        <SuccessState data={data} />
      </StyledCustomDialog>

      <StyledCustomDialog
        open={showFailedDialog}
        handleClose={() => setShowFailedDialog(false)}
      >
        <FailureState data={data} />
      </StyledCustomDialog>
    </>
  )
}
export default formSuccessAndFailure
